
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.302 6.68L.05 22.773l-.038.151a.834.834 0 00.001.275.892.892 0 00.2.423c.102.122.237.222.399.29.09.038.19.065.294.078l.172.01h31.846a1.2 1.2 0 00.467-.088c.162-.068.297-.169.4-.29a.885.885 0 00.2-.7.892.892 0 00-.039-.15L28.667 6.696a.967.967 0 00-.387-.507A1.123 1.123 0 0027.627 6H6.337a1.159 1.159 0 00-.294.033c-.24.057-.454.191-.596.375a.916.916 0 00-.145.272zm5.425 1.208l-1.2 5.63h3.404l-.705-.679a.875.875 0 01.054-1.333 1.146 1.146 0 011.492.048l2.35 2.258.063.067.11.156.073.172.034.185-.006.185-.048.182-.087.17-.118.148-2.777 2.325a1.147 1.147 0 01-1.492-.045c-.399-.38-.376-.978.05-1.335l.738-.615H9.124l-1.429 6.705h23.837L26.857 7.888h-16.13z","fill":"currentColor"}})])
          )
        }
      }
    